export const FEATURE_NAME = '@zerops/zerops/feature/service-stack-form/modules/python-service-stack-form';
